import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import Icono from '../Icono';
import { servicios } from '../../config/servicios';
import {
  CORREO,
  TELEFONO,
  UBICACION,
  REDES,
  WHATSAPP_VISIBLE,
  enlaceWhatsApp,
} from '../../config/contacto';

// Pie completo: nombre, ubicación y contacto (NAP) iguales en todas las
// páginas, porque es lo que Google y la gente comparan para confiar en que el
// negocio existe. Lo que no está confirmado (teléfono fijo, dirección, redes)
// no se pinta: ver config/contacto.js.
function Footer() {
  const anio = new Date().getFullYear();
  return (
    <footer className="pie zona-oscura">
      <div className="contenedor">
        <div className="pie__rejilla">
          <div className="pie__marca">
            <p className="pie__nombre">Kiwi Dinámico</p>
            <p className="pie__lema">
              Soporte, redes, software a medida y facturación electrónica para pymes de Costa Rica.
            </p>
            <a className="btn btn--primario" href={enlaceWhatsApp()} target="_blank" rel="noopener noreferrer">
              <Icono nombre="chat" />
              Hablemos por WhatsApp
            </a>
          </div>

          <nav className="pie__columna" aria-label="Servicios">
            <h2 className="pie__titulo">Servicios</h2>
            <ul>
              {servicios.map((s) => (
                <li key={s.slug}>
                  <Link to={`/servicios/${s.slug}`}>{s.corto}</Link>
                </li>
              ))}
              <li>
                {/* Página estática aparte: <a>, no <Link>. */}
                <a href="/erp/">Kiwi ERP: facturación electrónica</a>
              </li>
              <li>
                <Link to="/licencias">Licencias Microsoft</Link>
              </li>
            </ul>
          </nav>

          <nav className="pie__columna" aria-label="Empresa">
            <h2 className="pie__titulo">Empresa</h2>
            <ul>
              <li>
                <Link to="/nosotros">Nosotros</Link>
              </li>
              <li>
                <Link to="/blog">Blog</Link>
              </li>
              <li>
                <Link to="/productos">Herramientas recomendadas</Link>
              </li>
              <li>
                <Link to="/contacto">Contacto</Link>
              </li>
            </ul>
          </nav>

          <div className="pie__columna">
            <h2 className="pie__titulo">Contacto</h2>
            <address className="pie__nap">
              <span className="pie__dato">
                <Icono nombre="chat" />
                <a href={enlaceWhatsApp()} target="_blank" rel="noopener noreferrer">
                  WhatsApp {WHATSAPP_VISIBLE}
                </a>
              </span>
              {TELEFONO && (
                <span className="pie__dato">
                  <Icono nombre="telefono" />
                  <a href={`tel:${TELEFONO.replace(/[^+\d]/g, '')}`}>{TELEFONO}</a>
                </span>
              )}
              <span className="pie__dato">
                <Icono nombre="correo" />
                <a href={`mailto:${CORREO}`}>{CORREO}</a>
              </span>
              <span className="pie__dato">
                <Icono nombre="ubicacion" />
                <span>{UBICACION}</span>
              </span>
            </address>
            {REDES.length > 0 && (
              <ul className="pie__redes" aria-label="Redes sociales">
                {REDES.map((r) => (
                  <li key={r.url}>
                    <a href={r.url} target="_blank" rel="noopener noreferrer">
                      {r.nombre}
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        <div className="pie__base">
          <p>© {anio} Kiwi Dinámico. Costa Rica.</p>
          <ul>
            <li>
              <Link to="/politica-privacidad">Política de privacidad</Link>
            </li>
            <li>
              <Link to="/terminos-condiciones">Términos y condiciones</Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
